import { USDCContract } from "./usdc"
import { BUSDContract } from "./busd"
import { DAIContract } from "./dai"
import { USDTContract } from "./usdt"

export const stableCoins = [
  { symbol: 'USDT', contract: USDTContract, swapIndex: 0 },
  { symbol: 'BUSD', contract: BUSDContract, swapIndex: 1 },
  { symbol: 'USDC', contract: USDCContract, swapIndex: 2 },
  { symbol: 'DAI', contract: DAIContract, swapIndex: 3 },
]

export const stableCoinsOnEOG_Competition = [
  {
    tokenName: 'USDT',
    index: 0,
  },
  // {
  //   tokenName: 'USDC',    // it is commented temporarily until find a way, because USDC is using a proxy contract
  //   index: 1,
  // },
  {
    tokenName: 'BUSD',
    index: 2,
  },
  {
    tokenName: 'DAI',
    index: 3,
  }
]
